import { render } from "./searchbar.vue?vue&type=template&id=188bd272"
import script from "./searchbar.vue?vue&type=script&lang=js"
export * from "./searchbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__